import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { PageHeader } from "@/components/layout/PageHeader";
import { t } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";
import { FacilitiesLivePage } from "./facilities/Live";
import { MapsPage } from "./facilities/Maps";
import { ShowModesPage } from "./facilities/ShowModes";

type SubNavEntry = { to: string; label: string; adminOnly?: boolean };

const SUB_NAV: SubNavEntry[] = [
  { to: "live", label: t("Live") },
  { to: "plaene", label: t("Pläne"), adminOnly: true },
  { to: "show-modi", label: t("Show-Modi"), adminOnly: true },
];

export function FacilitiesPage() {
  const { isAdmin } = useAuth();
  return (
    <div>
      <PageHeader
        title={t("Anlagen")}
        description={t("Pläne, Live-Status der Marker und Show-Modi für Wallboards")}
      />
      <SubNav isAdmin={isAdmin} />
      <Routes>
        <Route index element={<Navigate to="live" replace />} />
        <Route path="live" element={<FacilitiesLivePage />} />
        {isAdmin ? (
          <>
            <Route path="plaene" element={<MapsPage />} />
            <Route path="show-modi" element={<ShowModesPage />} />
          </>
        ) : (
          <>
            <Route path="plaene" element={<Navigate to="../live" replace />} />
            <Route path="show-modi" element={<Navigate to="../live" replace />} />
          </>
        )}
      </Routes>
    </div>
  );
}

function SubNav({ isAdmin }: { isAdmin: boolean }) {
  const items = SUB_NAV.filter((i) => isAdmin || !i.adminOnly);
  return (
    // Mobil: horizontal scrollbare Leiste statt Umbruch/Overflow; Scrollbar versteckt.
    <div className="flex gap-1 overflow-x-auto border-b border-border px-3 py-2 [scrollbar-width:none] md:px-6 [&::-webkit-scrollbar]:hidden">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            cn(
              "shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-xs font-medium transition-colors md:py-1",
              isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:bg-muted",
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  );
}
